import React from "react";

const HeaderList = () => {
  return (
    <thead className="py-2 text-left text-gray-700 leading-4 bg-gray-100 rounded">
      <tr>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Colaborador
        </th>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          DNI
        </th>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Correo electrónico
        </th>
        
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
         Contraseña
        </th>
        
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
         Eliminar / Activar
        </th>

        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
         Estado
        </th>
      </tr>
    </thead>
  );
};

export default HeaderList;